import styled, { css, StyledComponent } from 'styled-components';
import { InputText } from '../Typography';

export interface IInputBaseProps {
  name?: string;
  type?: string;
  placeholder?: string;
  outlined?: boolean;
  errored?: boolean;
  onChange?: (e: React.SyntheticEvent) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const InputBase = styled<StyledComponent<'div', {}, IInputBaseProps>>(
  InputText
)`
  display: block;
  color: ${({ theme }) => theme.palette.foreground.primary};
  background-color: ${({ theme }) => theme.palette.background.input};
  outline: none;
  padding: 0.75rem 1rem;
  border: 0.125rem solid transparent;
  border-radius: 0.5rem;
  box-sizing: border-box;
  min-height: 3rem;
  width: 100%;
  text-align: inherit;

  :focus,
  :active {
    background-color: ${({ theme }) => theme.palette.background.inputActive};
  }

  ::placeholder {
    color: ${({ theme }) => theme.palette.foreground.inputPlaceholder};
  }

  ${({ outlined, theme, errored }) => {
    if (outlined && !errored) {
      return css`
        background-color: transparent;
        border: 0.125rem solid ${theme.palette.background.input};

        :focus,
        :active {
          background-color: transparent;
          border-color: ${theme.palette.foreground.cta};
        }
      `;
    }
    if (errored) {
      return css`
        background-color: transparent;
        border: 0.125rem solid ${theme.palette.indicator.negative};

        :focus,
        :active {
          background-color: transparent;
          border-color: ${theme.palette.indicator.negative};
        }
      `;
    }
  }}
`;
